import { InfoIcon } from "components/SvgIcons"
import { LazyTooltipStep } from "components/TooltipStep/LazyTooltipStep"
import { v4 as uuidV4 } from "uuid"
import React, { useState } from "react"

export const MembershipPerksTooltip = ({
  info,
}: {
  info: string
}): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)
  const id = uuidV4()
  const tooltipJourneyStep = [
    {
      title: "Membership Perks",
      intro: info,
      element: `#list-info-${id}`,
      position: "right",
    },
  ]
  return (
    <>
      <button
        id={`list-info-${id}`}
        type="button"
        onClick={() => setIsOpen(true)}
      >
        <InfoIcon />
      </button>
      {isOpen && (
        <LazyTooltipStep
          steps={tooltipJourneyStep}
          onComplete={() => {
            setIsOpen(false)
          }}
          time={0}
          isTooltipOpen={isOpen}
          scrollTopOnComplete={false}
        />
      )}
    </>
  )
}
